import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import ClearIcon from '@mui/icons-material/Clear';
import Button from '@mui/material/Button';

type DeleteStoryProps = {
  closeModal: () => void;
  onDelete: () => void;
};

export default function DeleteStory({
  closeModal,
  onDelete,
}: DeleteStoryProps) {
  function handleOnDeleteTree() {
    if (onDelete) {
      onDelete();
    }
  }
  return (
    <Box
      p={3}
      sx={{
        animation: 'storyDeleteFade 220ms cubic-bezier(0.2, 0, 0, 1)',
        '@keyframes storyDeleteFade': {
          '0%': { opacity: 0, transform: 'translateY(5px)' },
          '100%': { opacity: 1, transform: 'translateY(0)' },
        },
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', py: 1 }}>
        <Typography variant="h5" fontWeight={700}>
          Delete story
        </Typography>
        <IconButton onClick={closeModal}>
          <ClearIcon />
        </IconButton>
      </Box>
      <Box
        py={1}
        sx={{
          display: 'flex',
          gap: 1,
          alignItems: 'flex-start',
        }}
      >
        <Typography variant="body1">
          Are you sure you want to delete this story? This action is permanent
          and cannot be undone.
        </Typography>
      </Box>
      <Box
        py={2}
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          gap: 2,
          alignItems: 'center',
        }}
      >
        <Button
          variant="outlined"
          onClick={closeModal}
          sx={{ borderRadius: 2, minHeight: 40, px: 2, textTransform: 'none' }}
        >
          No
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={handleOnDeleteTree}
          sx={{ borderRadius: 2, minHeight: 40, px: 2, textTransform: 'none' }}
        >
          Yes
        </Button>
      </Box>
    </Box>
  );
}
